import reducer from "./reducer";
export { default as ClassificationApplicantsTypes } from "./components/index";
export { default as classificationApplicantsTypesReducerName } from "./constants";
export default reducer;
